import { useForm } from 'react-hook-form';
import { useModal } from '../../contexts/ModalContext';
import FormModalLayout from '../layouts/FormModalLayout';
import FormAutocomplete from './FormAutocomplete';
import { EVENT_TYPE_OPTIONS, MARKET_TYPE_USED_FOR_OPTIONS, QUERY_KEYS } from '../../constants';
import { EventType, MarketType, MarketTypeUsedFor } from '../../@types/api';
import useMutateData from '../../hooks/useMutateData';
import { useCallback } from 'react';
import FormSelect from '../molecules/FormSelect';
import { ensureArray } from '../../utils';
import { getMarketTypeName } from '../../helpers';
import { EVENT_TYPE } from '../../constants/enums';

type FormData = {
  marketTypeCombiningIds: string[];
  usedFor: MarketTypeUsedFor[];
  type: EventType;
};

const MarketCombiningTab = () => {
  const { item, closeModal } = useModal<MarketType>();

  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm<FormData>({
    defaultValues: {
      marketTypeCombiningIds: item?.marketTypeCombiningIds || [],
      usedFor: item?.usedFor,
      type: EVENT_TYPE.MATCH,
    },
  });

  const { updateData } = useMutateData('market-types', [QUERY_KEYS.marketTypes]);

  const onFormSubmit = (data: FormData) => {
    if (!item) return;

    updateData(item?.id, { marketTypeCombiningIds: data.marketTypeCombiningIds }, () => {
      closeModal?.();
    });
  };

  const getOptionLabel = useCallback((options: MarketType[], value: string) => {
    const option = options.find((opt) => opt?.id === value);

    return option ? getMarketTypeName(option) : '';
  }, []);

  const marketTypeCombiningIds = watch('marketTypeCombiningIds');
  const usedFor = watch('usedFor');
  const type = watch('type');

  return (
    <FormModalLayout label={getMarketTypeName(item)} onClose={closeModal} onSave={handleSubmit(onFormSubmit)}>
      <FormSelect
        label='Used for'
        name='usedFor'
        control={control}
        options={MARKET_TYPE_USED_FOR_OPTIONS}
        multiple
        closeOnSelect
        error={errors.usedFor}
      />
      <FormSelect
        label='Type'
        name='type'
        control={control}
        options={EVENT_TYPE_OPTIONS}
        closeOnSelect
        error={errors.type}
      />
      <FormAutocomplete<MarketType, FormData>
        control={control}
        label='Can combine with'
        name='marketTypeCombiningIds'
        multiple
        url='market-types'
        queryKey={[QUERY_KEYS.marketTypes, item?.sportId, marketTypeCombiningIds, usedFor, type]}
        queryParams={{
          sportId: item?.sportId,
          marketTypeIds: marketTypeCombiningIds,
          canCombineWithId: item?.id,
          usedFor: ensureArray(usedFor),
          type,
        }}
        getOptionLabel={getOptionLabel}
      />
    </FormModalLayout>
  );
};

export default MarketCombiningTab;
